import { Component, ViewChild } from '@angular/core';
import { SettingsService } from '@delon/theme';
import {Router} from "@angular/router";
import {JyMenuService} from "../../../routes/jy-authorization/menu/jy-menu.service";
import {CommonsService} from "@core/service/commons.service";
import {environment} from "@env/environment";

@Component({
  selector: 'layout-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  searchToggleStatus: boolean;

  constructor(public settings: SettingsService,private router:Router,private jyMenuService:JyMenuService,private commonsService:CommonsService) { }

  toggleCollapsedSideabar() {
    this.settings.setLayout('collapsed', !this.settings.layout.collapsed);
  }

  searchToggleChange() {
    this.searchToggleStatus = !this.searchToggleStatus;
  }
  public localTime:Date = new Date();
  public poorTime:number = 0;//服务器时间和本地时间差值
  getCurrentTime(){
    this.jyMenuService.getCurrentTime().subscribe((res:any) => {
      if(res.status === 'success'){
        this.localTime = res.data;
        this.poorTime = new Date(res.data).getTime() - new Date().getTime();
        this.commonsService.poorTime = this.poorTime;
      }
    })
  }

  public systemProd:boolean = false; //是否为正式系统
  ngOnInit() {
    this.getCurrentTime();
    setInterval(()=>{
      let timeNum = new Date().getTime() + this.poorTime;
      this.localTime = new Date(timeNum);
    },1000);

    //区分正式环境和测试环境
    if(environment.prod){
      this.systemProd = true;
    }
  }

//  点击锁屏存储当前的路由
  sessionSet(){
    sessionStorage.setItem('lockBeforeUrl',this.router.url);
  }

//  点击此图标跳转到首页
  homePage(){
    this.router.navigateByUrl("/supplier-portal/home-page");
  }
}
